import React from 'react';
import './ChatMessage.css'; // Import your CSS file for chat styling

export interface ChatMessageProps {
  message: string;
  role: 'BidBro' | 'User' | 'Contractor';
  timestamp: string;
  displayName: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, role, timestamp, displayName }) => {
  const isUser = role === 'User';

  const getMessageClass = () => {
    if (isUser) {
      return 'user-message';
    } else if (role === 'BidBro') {
      return 'bidbro-message';
    } else {
      return 'contractor-message';
    }
  };

  const getAlignment = () => {
    return isUser ? 'right' : 'left';
  };

  return (
    <div className={`message-wrapper ${getAlignment()}`}>
      <div className={`chat-message ${getMessageClass()}`}>
        <div className="message-header">
          <span className="message-author">{role === 'BidBro' ? 'BidBro' : displayName}</span>
          <span className="message-time">{new Date(timestamp).toLocaleString()}</span>
        </div>
        <div className="message-content" dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    </div>
  );
};

export default ChatMessage;